import { MAX_AMOUNT, toPaise } from "../AddMoneyToUser/addMoneyUtils";

// Rules for the "minimum balance" a user sets on their own Policy Wallet (the navbar bell warns while the balance is
// at or below it). Same limits as the server (PUT /policyWallet/minimum): a plain amount from 0 to 1,00,00,000 with at
// most 2 decimals, and 0 turns the warning off. Money is parsed in whole paise, never as a float.

/** "" when valid, otherwise the message to show under the field. */
export const validateMinimum = (value) => {
  const text = String(value ?? "")
    .trim()
    .replace(/\.$/, "");
  if (!text) return "Enter a minimum balance (0 turns the warning off)";
  if (/^\d+\.\d{3,}$/.test(text)) return "Maximum 2 decimal places";
  const paise = toPaise(text);
  if (Number.isNaN(paise)) return "Enter a valid amount";
  if (paise > MAX_AMOUNT * 100) return `Minimum cannot exceed ₹ ${MAX_AMOUNT.toLocaleString("en-IN")}`;
  return "";
};

/** The amount to send, as a number; only call it for a value that passed validateMinimum. */
export const minimumAmount = (value) => toPaise(value) / 100;
